import React, { lazy, Suspense } from 'react';
import { useSelector } from 'react-redux';

// import selectors
import { getStartFrontend } from 'js/store/app/App.selectors';

// import router
import RouterMain from 'js/containers/router/Router.main';

// import componenets
import GenericScrollToTop from 'js/components/generic/Generic.scroll-to-top';

// import sections
import SectionHeader from 'js/containers/section/Section.header';

// import models
import ModelVideoPopup from 'js/containers/modal/Model.video-popup';
import GallerySubmissionStatus from 'js/components/gallery/Gallery.submission-status';

// lazy load containers
const SectionUpdates = lazy(() => import('js/containers/section/Section.updates'));
const SectionFooter = lazy(() => import('js/containers/section/Section.footer'));
const SectionComingSoon = lazy(() => import('js/containers/section/Section.coming-soon'));

const App = () => {
  const startFrontend = useSelector((state) => {
    return getStartFrontend(state);
  });

  const previewMode = useSelector((state) => {
    return state.app.previewMode;
  });

  const renderSite = () => {
    return (
      <>
        <GallerySubmissionStatus />
        <ModelVideoPopup />
        <SectionHeader />
        <RouterMain />
        <Suspense fallback={<div>Loading...</div>}>
          <>
            <SectionComingSoon />
            <SectionUpdates />
            <SectionFooter />
          </>
        </Suspense>
        <GenericScrollToTop />
        {previewMode && <div className="preview-mode">Currently in preview mode</div>}
      </>
    );
  };

  return startFrontend ? renderSite() : null;
};

export default App;
